import { render } from "./media-control-next.svg?vue&type=template&id=1b02dc1e"
const script = {}
script.render = render

export default script